<template>
  <div>
    <div class="animated fadeIn">
      <div class="row">
        <div class="col-sm-12">
          <div class="card">
            <div class="card-header">
              <span class="title_head">Search User</span>
            </div>
            <b-collapse id="collapse1" visible>
              <b-card-body>
                <b-row>
                  <b-col md="6">
                    <b-form-group>
                      <b-form-input
                        type="text"
                        placeholder="Enter Username"
                        v-model="search_uname"
                        name="username"
                      ></b-form-input>
                    </b-form-group>
                  </b-col>
                  <b-col md="6">
                    <button
                      type="button"
                      class="btn btn-pill btn-primary serach_bttn"
                      style="margin-top: 2px;"
                      @click.prevent="getuser"
                    >
                      <i class="fa fa-search"></i> Search
                    </button>
                  </b-col>
                </b-row>
              </b-card-body>
            </b-collapse>
          </div>
        </div>
      </div>
    </div>

    <div class="animated fadeIn">
      <div class="row">
        <div class="col-sm-12">
          <div class="card">
            <div class="card-header">
              <div class="title_head">
                <b-row>
                  <b-col sm="2">User's List</b-col>
                  <b-col sm="2">
                    <b-form-select v-model="selected" v-on:change="typechange">
                      <option value="all">All</option>
                      <option value="verified">Verified</option>
                      <option value="not_verified">Not Verified</option>
                    </b-form-select>
                  </b-col>
                  <b-col sm="8"></b-col>
                </b-row>
              </div>
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-sm-12">
                  <div v-if="message.sucess != ''" class="alert alert-success">
                    <center>{{ message.sucess }}</center>
                  </div>
                </div>
              </div>
              <div class="table-responsive-sm">
                <vue-good-table
                  :columns="columns"
                  :rows="rows"
                  mode="remote"
                  ref="my-table"
                  @on-column-filter="onColumnFilter"
                  @on-page-change="onPageChange"
                  @on-sort-change="onSortChange"
                  @on-per-page-change="onPerPageChange"
                  :totalRows="totalRecords"
                  :pagination-options="{ enabled: true, perPage: 10 }"
                  styleClass="vgt-table striped bordered table-sm condensed"
                >
                  <template slot="table-row" slot-scope="props">
                    {{ props.formattedRow[props.column.field] }}
                  </template>
                </vue-good-table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Spinner v-if="loading"></Spinner>
  </div>
</template>
<script>
import Spinner from "../../spinner.vue";
export default {
  name: "Variant",
  components: { Spinner },
  data() {
    return {
      shpfrst_time: false,
      selected: "all",
      largeModal: false,
      loading: false,
      search_uname: "",
      totalRecords: 0,
      serverParams: {
        columnFilters: {},
        sort: {},
        page: 1,
        perPage: 10,
      },
      columns: [
        {
          label: "Company Name",
          field: "companyname",
          width: "20% !important",
        },
        {
          label: "Username",
          field: "username",
          width: "17% !important",
        },
        {
          label: "Email",
          field: "email",
          width: "20% !important",
        },
        {
          label: "Phone No.",
          field: "phone",
          width: "13% !important",
        },
        {
          label: "Registered Date",
          field: "created_datetime",
          width: "20% !important",
        },
      ],

      rows: [],

      error: {
        errorname: false,
        errorided: "",
        errornameed: "",
        errorvalue: false,
      },
      message: {
        sucess: "",
        sucess1: "",
      },
    };
  },

  created() {
    this.getuser();
  },

  methods: {
    updateParams(newProps) {
      this.serverParams = Object.assign({}, this.serverParams, newProps);
    },

    onPageChange(params) {
      this.updateParams({ page: params.currentPage });
      this.getuser();
    },

    onPerPageChange(params) {
      this.updateParams({ perPage: params.currentPerPage, page: 1 });
      this.getuser();
    },

    onSortChange(params) {
      this.updateParams({
        sort: {
          type: params.sortType,
          field: this.columns[params.columnIndex].field,
        },
        page: 1,
      });
      this.getuser();
    },

    onColumnFilter(params) {
      this.updateParams(params);
      this.getuser();
    },

    shopuser(val) {
      if (val === "comp") {
        if (this.shpfrst_time === false) {
          this.shpfrst_time = true;
        } else {
          return;
        }
      }
      var _this = this;
      this.$http
        .get("/api/shopusers")
        .then(function (response) {})
        .catch(function (error) {
          if (error.response.status === 401) {
            localStorage.clear();
            _this.$store.commit("SET_AUTH_USER", null);
            _this.$router.push("/");
          }
          if (
            error.response.data.error.message ===
            "Cannot read property 'cmpname' of null"
          ) {
            localStorage.clear();
            _this.$store.commit("SET_AUTH_USER", null);
            _this.$router.push("/");
          }
        });
    },

    // editvalue(data1) {
    // this.$store.commit('set_reg_view', true)
    // this.$store.commit('set_reg_rights', true)
    // this.$router.push({ name: 'Company Registration', params: { 'company_id': data1.company_id}})
    // console.log('editvalue')
    // },

    // viewvalue(data) {
    // this.$store.commit('set_reg_view', true)
    // this.$store.commit('set_reg_rights', false)
    // this.$router.push({ name: 'Company Registration', params: { 'company_id': data.company_id}})
    // console.log('viewvalue')
    // },

    typechange(current_type) {
      if (current_type !== undefined) {
        this.selected = current_type;
      }
      this.getuser();
    },

    getuser() {
      // var filteParam = {};
      var data = "";
      var filteParam = {};
      filteParam.page = this.serverParams.page;
      filteParam.perPage = this.serverParams.perPage;
      filteParam.sort = this.serverParams.sort;
      var search_like = "";
      if (this.search_uname != "") {
        search_like = "&filter[where][search_uname]=" + this.search_uname;
      }
      var api =
        "/api/users/user_email_detail?params=" +
        JSON.stringify(filteParam) +
        "&filter[where][emailVerified]=" +
        this.selected +
        search_like;

      this.loading = true;
      var _this = this;
      this.$http
        .get(api)
        .then(function (response) {
          if (response.data != undefined) {
            _this.totalRecords = response.data[0].totalRecords;
            response.data.shift();
            _this.rows = response.data;
          }
          _this.loading = false;
        })
        .catch(function (error) {
          _this.loading = false;
        });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/admin_pages/user_mgmt.vue